module.exports = __webpack_public_path__ + "static/img/step04.1ff1c78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/applyprocess/step04.png
// module id = d+F2
// module chunks = 1